import React, { useEffect } from "react";
import { Form } from "antd";
import InputWithLabel from "shared/InputWithLabel";
import AuthService from "auth";
import {
  EMAIL_RULES,
  EMAIL_VALIDATE_TRIGGER,
  PASSWORD_RULES,
  PHONE_RULES,
  confirmPasswordRules,
  firstNameRules,
  lastNameRules,
} from "utils/validation";
import {
  FlexContainer,
  BodyContainer,
  ButtonWrapper,
  Heading,
  SubHeading,
  MainContainer,
  StyledButton,
  StyledCheckbox,
} from "./styles";

const FirstStep = ({ Next, setStepsPayload, stepsPayload }) => {
  const [form] = Form.useForm();
  const cachedUser = AuthService.getUser();
  const isCompletingProfile = Boolean(cachedUser?.email);

  useEffect(() => {
    const profile = stepsPayload.profileInfo;
    form.setFieldsValue({
      email: profile.email || cachedUser?.email || "",
      firstName: profile.firstName || cachedUser?.firstName || "",
      lastName: profile.lastName || cachedUser?.lastName || "",
      phoneNumber: profile.phoneNumber || cachedUser?.phoneNumber || "",
      referralCode: profile.referralCode || "",
    });
  }, [cachedUser, form, stepsPayload.profileInfo]);

  const onFinish = (values) => {
    const { confirmPassword, password, ...rest } = values;
    const profileInfo = isCompletingProfile
      ? { ...rest, email: cachedUser.email }
      : { ...rest, ...(password ? { password } : {}) };
    setStepsPayload({ ...stepsPayload, profileInfo });
    Next();
  };

  return (
    <MainContainer>
      <Heading>Complete Your Profile</Heading>
      <SubHeading>
        {isCompletingProfile
          ? "Add your contact details to finish setting up your account"
          : "Enter your details"}
      </SubHeading>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <BodyContainer>
          <FlexContainer>
            <InputWithLabel
              label="First Name"
              name="firstName"
              placeholder="Enter your First Name"
              rules={firstNameRules}
            />
            <InputWithLabel
              label="Last Name"
              name="lastName"
              placeholder="Enter your Last Name"
              rules={lastNameRules}
            />
          </FlexContainer>
          <FlexContainer>
            <InputWithLabel
              label="Email Address"
              type="email"
              name="email"
              placeholder="Enter your Email Address"
              rules={EMAIL_RULES}
              validateTrigger={EMAIL_VALIDATE_TRIGGER}
              disabled={isCompletingProfile}
            />
            <InputWithLabel
              label="Phone Number"
              name="phoneNumber"
              placeholder="+1 (123) 456-7890"
              rules={PHONE_RULES}
            />
          </FlexContainer>
          {!isCompletingProfile && (
            <FlexContainer>
              <InputWithLabel
                label="Create Password"
                type="password"
                name="password"
                placeholder="Enter your Password"
                rules={PASSWORD_RULES}
              />
              <InputWithLabel
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                placeholder="Confirm your Password"
                dependencies={["password"]}
                rules={confirmPasswordRules("password")}
              />
            </FlexContainer>
          )}
          <FlexContainer>
            <InputWithLabel
              label="Referral Code"
              name="referralCode"
              placeholder="Enter your Referral Code (Optional)"
              rules={[]}
            />
          </FlexContainer>
        </BodyContainer>
        <Form.Item name="updates" valuePropName="checked" rules={[]}>
          <StyledCheckbox>
            Receive order updates, deals & tips via SMS from EcomDropship
          </StyledCheckbox>
        </Form.Item>
        <ButtonWrapper>
          <StyledButton type="primary" htmlType="submit" size="large">
            Continue
          </StyledButton>
        </ButtonWrapper>
      </Form>
    </MainContainer>
  );
};

export default FirstStep;
